export default __webpack_public_path__ + "static/media/trash_white.ca3ce96f.svg";